import { Pipe, PipeTransform } from '@angular/core';
import { CandidatStatusOnMission } from '../utils/enums';

@Pipe({
  name: 'stausCandidatMissionColor',
})
export class StausCandidatMissionColorPipe implements PipeTransform {
  transform(value: string): unknown {
    switch (value) {
      case CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION:
        return 'text-warn';
      case CandidatStatusOnMission.ACCEPTED:
        return 'text-accent-green';
      case CandidatStatusOnMission.REJECTED:
        return 'required';
      case CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH:
        return 'text-accent-green';
      case CandidatStatusOnMission.PAYMENT_DONE:
        return 'text-accent-green';
      case CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION:
        return 'text-warn';
      case CandidatStatusOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT:
        return 'text-warn';
      case CandidatStatusOnMission.ARCHIVED:
        return 'text-neutral-dark-grey';
      case CandidatStatusOnMission.NEUTRAL:
        return 'text-neutral-dark-grey';
      case CandidatStatusOnMission.RESERVED:
        return 'Réservé';
      case CandidatStatusOnMission.VALIDATION_REJECTED_BY_ESTABLISHMENT:
        return 'required';
      case CandidatStatusOnMission.CANCELED_BY_CANDIDATE:
        return 'required';
      case CandidatStatusOnMission.CANCELLATION_REQUEST_AFTER_SIGN_CONTRACT:
        return 'required';
      default:
        return 'Publiée en attente';
    }
  }
}
